import type { VisibleCopy, VisualPlan } from '@shared/creativeBrief';

/** Describe approved words and saved product visibility, without rewriting the
 * strategic brief or inventing details about a scene that has not rendered. */
export function adDescription(copy: VisibleCopy | undefined, plan?: VisualPlan): string | undefined {
  const message=copy?.groups.find(group=>group.type==='headline')?.elements.find(element=>element.text.trim())?.text.trim()
    ?? copy?.groups.find(group=>group.type==='support')?.elements.find(element=>element.text.trim())?.text.trim();
  if(!message)return;
  if(plan?.productVisibility==='none')return `The ad presents “${message}” without showing the product.`;
  if(plan?.productVisibility==='hero'||plan?.productVisibility==='secondary')return `The ad features the product with the message “${message}”.`;
  return `The ad presents the message “${message}”.`;
}
